import { Component, ViewChild } from '@angular/core';
import { NavController, NavParams, Content, ViewController } from 'ionic-angular';
import { FamilyAction } from '../../../actions/family.action';
import { AbstractPage } from '../../_com/abstract-page';
import { FamilyDetailPage } from '../detail/family-detail';
import { FamilyEditPage } from './../edit/family-edit';
import { LoadingService } from './../../../providers/loading-service';

/**
 * Generated class for the FamilyListPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@Component({
  selector: 'page-family-list',
  templateUrl: 'family-list.html',
})
export class FamilyListPage extends AbstractPage{

	list = [];
  searchText = "";
  listType = "parents";
  @ViewChild(Content) content: Content;

  constructor(
  	public navCtrl: NavController, 
  	public navParams: NavParams,
  	public familyAction:FamilyAction,
    public viewController:ViewController,
    public loadingService: LoadingService,
  	) {
  	super();
  }

  ionViewDidEnter() {
    this.refresh(); //詳細画面からの戻りでもリフレッシュがかかるようにionViewDidEnterで実行
  }

  /**
   * モーダル表示か否かの判定
   */
  isModal(){
    return (this.navParams.data["modal"]);
  }

  /**
   * 画面タイトル取得
   */
  getTitle(){
    return (this.isModal()) ? "お客様(保護者)を選択" : "保護者一覧";
  }

  /**
   * アイテムを選択した際のイベント
   */
  onItemSelect(d){
    if(this.isModal()){
      this.viewController.dismiss(d);
    } else {
      this.navCtrl.push(FamilyDetailPage, d);
    }
  }

  /**
   * モーダルを閉じる
   */
  dismiss(){
    this.viewController.dismiss();    
  }

  /**
   * リストリフレッシュ
   */
  refresh(){

    this.loadingService.present("");
    // super.scrollTop(this.content);
    this.familyAction.getList({searchText:this.searchText}).subscribe((res)=>{
      this.list = res["data"];
      this.loadingService.dissmiss();
    });
  }

  /**
   * 利用者追加
   */
  addFamily(){

    this.navCtrl.push(FamilyEditPage);
  }

  /**
   * サーチバーでの検索処理
   */
  searchedText = "";
  onSearch($event){
    if(this.searchText != this.searchedText){
      this.searchedText = this.searchText;
      this.refresh();
    }
  }
}


// WEBPACK FOOTER //
// ./src/pages/family/list/family-list.ts